import { fork } from 'redux-saga/effects';
import RedeemSaga from './RedeemSaga';
import PayoutSaga from './PayoutSaga';
import PrizeSaga from './PrizeSaga';
import TaxProfileSaga from './TaxProfileSaga';
import ParticipationSaga from './ParticipationSaga';
import LegalSaga from './LegalSaga';

export default function* () {
    yield fork(RedeemSaga);
    yield fork(PayoutSaga);
    yield fork(PrizeSaga);
    yield fork(TaxProfileSaga);
    yield fork(ParticipationSaga);
    yield fork(LegalSaga);
}
